module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "so2--dataset-cover.d9f27f27.jpg";